import React from 'react'

const AccountHeader = ({ activeTab, onSidebarToggle }) => {
  const title = activeTab === 'orders' ? 'შეკვეთები' : 'პროფილი'
  const fullTitle =
    activeTab === 'orders' ? 'თქვენი მიმდინარე შეკვეთები' : 'პროფილის დეტალები'
  const icon = activeTab === 'orders' ? 'fas fa-shopping-bag' : 'fas fa-user'

  return (
    <header className="px-4 sm:px-6 pt-6 pb-0">
      <div className="flex items-center justify-between gap-4">
        <h1 className="pl-1 text-lg sm:text-xl lg:text-2xl font-bold text-slate-900 flex items-center gap-3">
          <i className={`${icon} text-citrus-red`}></i>
          <span className="hidden sm:inline">{fullTitle}</span>
          <span className="sm:hidden">{title}</span>
        </h1>
        <button
          className="lg:hidden flex items-center justify-center w-10 h-10 bg-slate-50 border border-slate-200 rounded-xl text-slate-600"
          onClick={onSidebarToggle}
        >
          <i className="fas fa-bars"></i>
        </button>
      </div>
    </header>
  )
}

export default AccountHeader
